import { App as AntApp } from "antd";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams, useSearchParams } from "react-router";
import { useUserUpdateEmail } from "../../../common/api/queries/user";
import { EntityIdObject } from "../../../common/types";
import { AUTH_ROUTE_PATHS } from "../../auth/paths";
import { DASHBOARD_ROUTE_PATHS } from "../../dashboard/paths";

export const UpdateEmailContainer = () => {
  const { t } = useTranslation();
  const { modal } = AntApp.useApp();

  const { id } = useParams<EntityIdObject>() as { id: string };

  const navigate = useNavigate();
  const [urlParams] = useSearchParams();
  const token = urlParams.get("token");

  const updateEmail = useUserUpdateEmail();

  useEffect(() => {
    if (!token) {
      navigate(DASHBOARD_ROUTE_PATHS.homepage.to, { replace: true });
      return;
    }

    updateEmail.mutate(
      { id, object: { token } },
      {
        onSuccess: () => {
          modal.success({
            title: t("common.operationSuccess"),
            content: t("user.helpers.emailUpdateSuccess"),
            okText: t("user.actions.continueToLogin"),
            onOk: () => navigate(AUTH_ROUTE_PATHS.login.to, { replace: true }),
          });
        },
      },
    );
  }, [token]);

  return <></>;
};
